import PushSelfTest from './PushSelfTest.component'

export default PushSelfTest
